module.exports = __webpack_public_path__ + "img/monitorbox15.0c9d86ff.jpg";